import React, { useState, useEffect } from 'react';

const MediaPoster = ({
  mediaItem,
  editMode,
  isAdmin,
  onOpenImagePicker,
}) => {
  const [imageError, setImageError] = useState(false);

  useEffect(() => {
    // Reset image error state when mediaItem changes
    setImageError(false);
  }, [mediaItem?.vertical_image]);

  const onImageError = () => {
    console.error(`Failed to load image for ${mediaItem.type}: ${mediaItem.vertical_image}`);
    setImageError(true);
  };

  return (
    <section className="poster-section">
      {imageError || !mediaItem?.vertical_image ? (
        <div className="poster-placeholder">
          {mediaItem?.type === 'Anime' || mediaItem?.type === 'AnimeMovie' || mediaItem?.type === 'AnimeSerie'
            ? 'Anime Image Unavailable'
            : 'No Image Available'}
        </div>
      ) : (
        <img
          src={mediaItem.vertical_image}
          alt={`${mediaItem.title} poster`}
          className="poster-img"
          onError={onImageError}
        />
      )}
      {editMode && isAdmin && (
        <button type="button" className="upload-label" onClick={() => onOpenImagePicker?.('vertical')}>
          Change Poster
        </button>
      )}
    </section>
  );
};

export default MediaPoster;